import React, { useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';

const AddIoUnitMapping = ({ open, onCancel, onSubmit }) => {
        const [form] = Form.useForm();

        const handleOk = async () => {
                try {
                        const values = await form.validateFields();
                        const result = await onSubmit(values);

                        if (result?.status === 'success') {
                                form.resetFields();
                                onCancel(); // ✅ Close modal after successful add
                        }
                } catch (err) {
                        console.log('Validation or submission error:', err);
                }
        };

        useEffect(() => {
                if (!open) {
                        form.resetFields();
                }
        }, [open]);

        return (
                <Modal
                        title="Add IO Unit Mapping"
                        open={open}
                        onCancel={() => {
                                form.resetFields();
                                onCancel();
                        }}
                        onOk={handleOk}
                        footer={[
                                <Button
                                        key="cancel"
                                        onClick={onCancel}>
                                        Cancel
                                </Button>,
                                <Button
                                        key="submit"
                                        type="primary"
                                        onClick={handleOk}>
                                        Add IO Unit Mapping
                                </Button>,
                        ]}
                        width={600}>
                        <Form
                                form={form}
                                layout="vertical"
                                className="custom-form-scroll"
                                style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                {[
                                        { label: 'IO Number', name: 'IO_NO' },
                                        { label: 'Revision Number', name: 'REV_NO' },
                                        { label: 'Manufacturing Unit', name: 'MNF_UNIT' },
                                        { label: 'Unit Name', name: 'UNIT_NAME' },
                                ].map(({ label, name }) => (
                                        <Form.Item
                                                key={name}
                                                name={name}
                                                label={
                                                        <div className="flex justify-between items-center gap-2">
                                                                <label className="text-left pr-4">
                                                                        {label}
                                                                        <span className="text-red-500">*</span>
                                                                </label>
                                                        </div>
                                                }
                                                labelCol={{ span: 7 }} // Roughly 40% in 24-grid system
                                                wrapperCol={{ span: 14 }} // Remaining 60%
                                                layout="horizontal"
                                                required={false} // ✅ Suppresses automatic red asterisk
                                                rules={[
                                                        {
                                                                required: true,
                                                                message: `${label} is required`,
                                                        },
                                                ]}>
                                                <Input className="w-full" />
                                        </Form.Item>
                                ))}
                        </Form>
                </Modal>
        );
};

export default AddIoUnitMapping;
